import { useEffect } from 'react'
import { Box } from '@mui/material'
import { useAppSelector } from 'app/hooks'
import { useMemo } from 'react'
import { selectAuthentications } from 'slices/authenticationsSlice'
import ChangePassword from 'views/ChangePassword/ChangePassword'
import Login from 'views/Login/Login'

function App() {
  const { token } = useAppSelector(selectAuthentications)
  const backgroundColor = useMemo(() => token && '#e6ebf4', [token])
  useEffect(() => {
    process.env.REACT_APP_VERSION && console.info(`Version=${process.env.REACT_APP_VERSION}`)
  }, [])

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor }}>
      {token ? <ChangePassword /> : <Login />}
    </Box>
  )
}

export default App
